/**
 * Represents card statistics, extending the backend card statistics.
 * This class is used to retrieve card statistics for the frontend.
 */
import { CardStats as BackendCardStats } from "@longtail-education/superprepstudy-data-model-frontend"

export class CardStats extends BackendCardStats {

  /**
   * Creates an instance of CardStats.
   * @param cardId The unique identifier of the card for which statistics are to be retrieved.
   */
  constructor(cardId: string | undefined) {
    // If the cardId is not provided, return immediately.
    if (!cardId) { return; }

    // Calls the constructor of the superclass (BackendCardStats) with the provided cardId.
    super(cardId)
  }
}
